import './about-us.css';

export function AboutUs(){
    return (
        <div className="max-w-6xl mx-auto p-6 grid grid-cols-1 gap-8" style={{marginTop: '7rem'}}>
            <h4>Welcome to Hotel Janas</h4>
            <p className="welcome-text">
            Located in the heart of Tirupati, Hotel Janas offers the perfect blend of comfort, convenience, and warm hospitality. As a premier 3-star hotel, 
            we are dedicated to providing our guests with a refined and relaxing experience—whether you're visiting for pilgrimage, business, or leisure.
            </p>
            <h4>
                Our Story
            </h4>
            <p>
            Founded with the vision of offering high-quality hospitality at an accessible price, Hotel Janas has become a trusted name for travelers seeking comfort and value in Tirupati. 
            Our commitment to service, cleanliness, and guest satisfaction has earned us the loyalty of visitors from across the country and beyond.
            </p>
            <h4>
             What We Offer   
            </h4>
            <div className='margin-bot-1'>
                <li key='comfortable-accomodation'>Well-appointed rooms designed for rest and relaxation</li>
                <li key='restaurant'>Our in-house dining destination offering a delightful selection of South Indian, North Indian cuisine</li>
                <li key='essential-amenties'>Free Wi-Fi, 24-hour front desk, room service, and secure parking</li>
                <li key='ideal-location'>Just minutes away from key landmarks, shopping areas, and transport hubs in Tirupati</li>
            </div>
            <h4>
            Our Mission
            </h4>
            <p>
            To provide guests with a seamless and comfortable stay experience marked by attentive service, clean accommodations, and heartfelt hospitality.
            </p>
            <h4>
            Why Choose Janas?  
            </h4>
            <div className='margin-bot-1'>
                <li key='prime-location'>Prime location in the spiritual and cultural heart of Tirupati</li>
                <li key='comfortable-rooms'>Comfortable, clean, and affordable rooms</li>
                <li key='mint'>In-house dining at Mint—a favorite among locals and guests</li>
                <li key='friendly-staff'>Friendly, professional staff committed to making your stay memorable</li>
            </div>
        </div>
    )
}